(function () {
  'use strict';

  function closeMenu(menu) {
    var toggle = menu.querySelector('[data-eride-account-toggle]');
    var panel = menu.querySelector('[data-eride-account-panel]');
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    menu.classList.remove('is-open');
  }

  function openMenu(menu) {
    var toggle = menu.querySelector('[data-eride-account-toggle]');
    var panel = menu.querySelector('[data-eride-account-panel]');
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    menu.classList.add('is-open');
  }

  function initAccountMenus() {
    document.querySelectorAll('[data-eride-account-menu]').forEach(function (menu) {
      var toggle = menu.querySelector('[data-eride-account-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var isOpen = menu.classList.contains('is-open');
        document.querySelectorAll('[data-eride-account-menu].is-open').forEach(function (other) {
          if (other !== menu) closeMenu(other);
        });
        if (isOpen) {
          closeMenu(menu);
        } else {
          openMenu(menu);
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-eride-account-menu]')) return;
      document.querySelectorAll('[data-eride-account-menu].is-open').forEach(closeMenu);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-eride-account-menu].is-open').forEach(closeMenu);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccountMenus);
  } else {
    initAccountMenus();
  }
})();
